import styled from "styled-components";

export const SquareDesign = styled.div`
    background: #000;
    top: 0px;
    left: 0px;
    box-sizing: border-box;
    position: absolute;
`;